import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { parseNumberByPrecision, useTranslation } from '@pascal/pascal-core';
import { roundInfoStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';

import HiLoBet from './hiLoBet';
import { useUpdateEffect } from '../../../helpers';
import { gameStore } from '../../../store/gameStore';
import Timer from '../../../containers/common/timer';
import { marketsStore } from '../../../store/marketsStore';
import CardResult from '../../../containers/common/cardResults';
import GameBetTabs from '../../../containers/common/gameBetTabs';
import { bonusIslandStore } from '../../../store/bonusIslandStore';
import { MobileTournamentWinning } from '../bonusIsland/mobileTournamentWinning';
import { BetBlock, HiLoButtonsBlock, TimerBlock } from '../../../containers/common';
import AutoBetAndRoundStepInfoComp from '../../../containers/common/betAndRoundStepInfo';
import { gameLiveConnection } from '../../../services/GameConnection';
import { MainBetsWrapper } from '../../../containers/common/gameBetTabs/mainBetsWrapper';
import BetSection from '../../web/betSection';

const startCoinAnimation = () => {
  const moneyWr = document.createElement('div');
  moneyWr.classList.add('money-animation-wr-mobile');
  const moneyInner = document.createElement('div');
  moneyInner.classList.add('money-animation-inner');

  moneyWr.appendChild(moneyInner);

  document.querySelector('.bonus-island-btn-mob')?.appendChild(moneyWr);

  const timeOut = setTimeout(() => {
    document.querySelectorAll('.money-animation-wr-mobile').forEach((el) => {
      if (!el.classList.contains('active')) {
        el.classList.add('active');
      }
    });
    clearTimeout(timeOut);
  }, 100);

  setTimeout(() => {
    moneyWr.remove();
  }, 2000);
};

const GameSection = observer(() => {
  const t = useTranslation();
  const { roundId } = roundInfoStore;
  const { replayActiveMainMoreSection } = marketsStore;
  const { ranges: rangesData, liveUpdateData } = bonusIslandStore;
  const [bonusWinAmount, setBonusWinAmount] = useState(0);
  const { ranges = [] } = rangesData;
  const { userId: liveUpdateDataUserId, winAmount } = liveUpdateData || {};
  const { mobileGameScene } = gameStore;
  const { userId } = userInfoStore;

  useUpdateEffect(() => {
    if (+userId === +liveUpdateDataUserId && ranges?.length) {
      startCoinAnimation();
      if (winAmount) {
        gameLiveConnection.getBalance();
        setBonusWinAmount(parseNumberByPrecision(1, winAmount));
        setTimeout(() => {
          setBonusWinAmount(0);
        }, 2000);
      }
    }
  }, [liveUpdateData, userId]);

  return (
    <div className={`mobile-game-holder ${mobileGameScene ? 'hide' : ''}`}>
      <div className='mobile-holder-game'>
        <div className='mobile-holder-game-inner'>
          <div className='mobile-holder-game-inner-left'>
            {!!bonusWinAmount && (
              <MobileTournamentWinning
                classname={'classname'}
                winText={t('WIN')}
                currencyCode={userInfoStore.currencyCode}
                winAmount={bonusWinAmount}
              />
            )}
            <div className='mob-game-cards-inside'>
              <div className='mob-game-small-cards'>
                <div className='mob-game-small-cards-ins'>
                  <div className='m-g-small-cards-wrp'>
                    <CardResult mobile />
                    <div className='mob-cards-back-wrp'>
                      <div className='mob-cards-back-item' />
                      <div className='mob-cards-back-item' />
                      <div className='mob-cards-back-item' />
                      <TimerBlock isMobile innerComp={Timer} key={roundId} />
                    </div>
                  </div>
                </div>
              </div>

              <AutoBetAndRoundStepInfoComp isMobile />
            </div>
          </div>
          <div className='mobile-holder-game-inner-right'>
            <GameBetTabs replayActiveMainMoreSection={replayActiveMainMoreSection} />
          </div>
        </div>
      </div>

      <div className='mobile-holder-hilo'>
        <div className='mobile-holder-hilo-inner'>
          <div className='mobile-holder-hilo-percent'>
            <MainBetsWrapper />
          </div>
          <div className='mobile-holder-hilo-btn'>
            <HiLoButtonsBlock innerComp={HiLoBet} />
          </div>
        </div>
      </div>

      <div className='mobile-holder-bet'>
        <BetBlock innerComp={BetSection} />
      </div>
    </div>
  );
});

export default GameSection;
